import { Component, Element, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-hotspots',
  styleUrl: 'hotspots.css',
  shadow: true,
})
export class CardHotspots {
  @Element() host: HTMLElement;

  @Prop() backgroundImage: string;

  loaded = false;
  style = {};

  getBGImageDimensions = (imageURL: string) => {
    return new Promise((resolve, reject) => {
      let image = new Image();
      image.onload = () => resolve({width: image.naturalWidth, height: image.naturalHeight});
      image.onerror = reject;
      image.src = imageURL;
    })
  }

  async componentWillLoad() {
    if (this.backgroundImage) {
      await this.getBGImageDimensions(this.backgroundImage)
        .then((dimensions: {width: number, height: number}) => {
          this.style = {
            ...this.style,
            aspectRatio: `${dimensions.width}/${dimensions.height}`,
            backgroundImage: `url(${this.backgroundImage})`
          }
          this.loaded = true;
        });
    } else {
      this.loaded = true;
    }
  }

  render() {
    return (
      this.loaded && <Host
        style={this.style}
      >
        <slot></slot>
      </Host>
    );
  }

}
